import logo from './img/logo.svg';

import gif from './img/Home/2.gif';

export const images = [
    logo,
    gif
];